import { render, staticRenderFns } from "./SisProgrammeStatusActions.vue?vue&type=template&id=6fff4c76&"
import script from "./SisProgrammeStatusActions.vue?vue&type=script&lang=ts&"
export * from "./SisProgrammeStatusActions.vue?vue&type=script&lang=ts&"
import style0 from "./SisProgrammeStatusActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports